const nicheImages = {
    creed: require('./niche/creed.png').default
};

export default nicheImages;